import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { useIntersection } from '../utils/intersectionObserver';

import { breakpoint } from './theme';

const containerStyles = css`
  max-width: 100%;
  width: 100%;
  position: relative;
  padding-top: 100%;
  display: block;
  text-decoration: none;
  overflow: hidden;
  border-radius: 8px;

  ${breakpoint.tabletUp} {
    border-radius: 20px;
  }

  ${breakpoint.desktopUp} {
    border-radius: 30px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${({ visible, error }) => {
      if (!visible && !error) {
        return 'white left top no-repeat url("data:image/gif;base64,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")'
      } else if( error ) {
        return 'lightgray'
      } else {
        return 'transparent'
      }
    }};
    background-size: 100% 100%;
  }
`;

const ThumbLink = styled.a`
  ${containerStyles};
`;

const ThumbDiv = styled.div`
  ${containerStyles};
`;

const Img = styled.img`
  border-radius: 8px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  border: 0;
  opacity: ${({ visible, error }) => (visible && !error) ? '1' : '0'};
  transition: opacity 0.2s linear 0s;

  ${breakpoint.tabletUp} {
    border-radius: 20px;
  }

  ${breakpoint.desktopUp} {
    border-radius: 30px;
  }
`;

const Thumb = ({ 
    href,
    image,
    className,
    title,
    sizeAll,
    sizeMobileSmall,
    sizeMobileBig,
    sizeMobile,
    sizeTablet,
    disableLazy,
    disableSmallImageLazy,
    dataSrc,
  }) => {
  const Tag = href ? ThumbLink : ThumbDiv;

  const pathPattern = /^\/[a-z]\//, namePattern = /[^\/]+$/g;

  const imgAr = image.split('.');
  const imagePath = imgAr[0].match(pathPattern)[0];
  const imageName = imgAr[0].match(namePattern)[0];
  const imageExt = imgAr[1];

  let src,
      srcSetAll,
      srcSetMobileSmall,
      srcSetMobileBig,
      srcSetMobile,
      srcSetTablet;

  const getSrc = size => {
    return `${imagePath}${size}x${size}/${imageName}-1x.${imageExt}`;
  }

  const getSrcSet = size => {
    return `${imagePath}${size}x${size}/${imageName}-1x.${imageExt} 1x, ${imagePath}${size}x${size}/${imageName}-2x.${imageExt} 2x`
  }

  if (sizeAll) {
    src = getSrc(sizeAll);
    srcSetAll = getSrcSet(sizeAll);
  } else {

    if (sizeMobileSmall) {
      src = getSrc(sizeMobileSmall);
      srcSetMobileSmall = getSrcSet(sizeMobileSmall);
    }

    if (sizeMobileBig) {
      srcSetMobileBig = getSrcSet(sizeMobileBig);
    }

    if (sizeMobile) {
      src = getSrc(sizeMobile);
      srcSetMobile = getSrcSet(sizeMobile);
    }

    if (sizeTablet) {
      srcSetTablet = getSrcSet(sizeTablet);
    }

    if(!(sizeMobileSmall || sizeMobileBig || sizeMobile || sizeTablet)) {
      src = `${imgAr[0]}-1x.${imgAr[1]}`;
      srcSetAll = `${imgAr[0]}-1x.${imgAr[1]} 1x, ${imgAr[0]}-2x.${imgAr[1]} 2x`;
    }
  }

  const [isInView, setIsInView] = useState(disableLazy);
  const imageRef = useRef(null);

  useIntersection(imageRef, () => {
    setIsInView(true);
  });

  const [ visible, setVisible ] = useState(false);
  const [ error, setError ] = useState(false);

  const handleLoad = () => {
    setVisible(true);
  }

  const handleError = () => {
    setError(true);
  }

  useEffect(() => {
    const { current } = imageRef;
    if (current && current.complete && current.src) {
      handleLoad();
    }
  }, []);

  return (
    <Tag
      className={className}
      href={href}
      title={ href && title ? title : ''}
      visible={visible}
      error={error}
    >
      <picture>
        {!(srcSetMobileSmall || srcSetMobileBig || srcSetTablet) && <source srcSet={srcSetAll} />}
        {srcSetMobileSmall && <source srcSet={isInView ? srcSetMobileSmall : null} media="(min-width: 0px) and (max-width: 479px)" />}
        {srcSetMobileBig && <source srcSet={isInView ? srcSetMobileBig : null} media="(min-width: 480px) and (max-width: 767px)" />}
        {srcSetMobile && <source srcSet={isInView ? srcSetMobile : null} media="(min-width: 0px) and (max-width: 767px)" />}
        {srcSetTablet && <source srcSet={isInView ? srcSetTablet : null} media="(min-width: 768px)" />}
        <Img
          src={(isInView || disableSmallImageLazy) ? src : null}
          data-src={dataSrc ? src : null}
          alt=""
          className={className}
          ref={imageRef}
          onLoad={handleLoad}
          onError={handleError}
          visible={visible || disableLazy || disableSmallImageLazy}
          error={error}
        />
      </picture>
    </Tag>
  )
};

export default Thumb;
